var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cat-list"},_vm._l((_vm.categories),function(data,key){return _c('li',[_c('router-link',{attrs:{"to":{ name: 'CategoryItems', params: { gender: 'all', category: key} }}},[_vm._v(_vm._s(data.name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }